<template>
  <div>
    <homeworkStatus :data="homeworkStatusData"></homeworkStatus>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import homeworkStatus from "../../homework/homeworkStatus";
export default {
  props: {
    data: {},
    columnData: {},
    status: {},
    editLocation: {}
  },
  data() {
    return {
      homeworkStatusData: {
        homeworkStatus: 0,
        homeworkStatusText: ""
      }
    };
  },
  components: {
    homeworkStatus
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.homeworkStatusData = {
        homeworkStatus: this.data.HomeworkStatus,
        homeworkStatusText: this.data.HomeworkStatusText
      };
      
    }
  },
  watch: {
    editLocation: function() {},
    data: function() {
      this.init();
    },
    status: function() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkStatusCell.vue